import { isChatSystemMessage } from '@/helpers/Common'
import { EUserStatus } from '..'

export class MessageModel {
  messageId!: number
  content: string = ''
  senderId!: number
  groupChatId!: number
  userName: string = ''
  userAvatar: string = ''
  userStatus!: EUserStatus
  timeSent?: Date // format YYYY/MM/DD HH:MM
  // data convert
  formatDate?: string
  isCanDelete: boolean = false
  liker: any[] = []
  isLike: boolean = false
  index: number = 0
  messageSpecial: boolean = false
  isOwnMsg: boolean = false
  replyMessage: MessageModel | null = null
  file: any = []
  is_html_content: boolean = false
  usersRead: any[] = []

  // translate
  isTranslated: boolean = false
  content_translation: string = ''
  constructor(init?: Partial<MessageModel>) {
    Object.assign(this, init)

    if (!this.is_html_content && this.file.length) {
      this.isTranslated = true
    }

    if (this.replyMessage?.content === 'chat_detail_message_deleted') {
      this.isTranslated = true
    }

    if (this.content === 'chat_detail_message_deleted') {
      this.isTranslated = true
    }

    if (isChatSystemMessage(this.content)) {
      this.isTranslated = true
    }
  }
}
